/**
 * Utility functions for time formatting and calculations
 */
export class TimeUtils {
    /**
     * Format seconds into MM:SS format
     * @param {number} seconds - Seconds to format
     * @returns {string} Formatted time string
     */
    static formatTime(seconds) {
        const absSeconds = Math.abs(seconds);
        const minutes = Math.floor(absSeconds / 60);
        const secs = absSeconds % 60;
        const sign = seconds < 0 ? '-' : '';
        return `${sign}${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    /**
     * Check if time has expired (negative)
     * @param {number} remainingTime - Remaining time in seconds
     * @returns {boolean} True if time expired
     */
    static isTimeExpired(remainingTime) {
        return remainingTime < 0;
    }

    /**
     * Get current timestamp in milliseconds
     * @returns {number} Current timestamp
     */
    static getCurrentTimestamp() {
        return Date.now();
    }

    /**
     * Convert milliseconds to seconds
     * @param {number} milliseconds - Milliseconds to convert
     * @returns {number} Seconds
     */
    static millisecondsToSeconds(milliseconds) {
        return Math.floor(milliseconds / 1000);
    }

    /**
     * Calculate progress percentage
     * @param {number} elapsed - Elapsed time in seconds
     * @param {number} total - Total time in seconds
     * @returns {number} Progress percentage (0-100)
     */
    static calculateProgress(elapsed, total) {
        if (total <= 0) return 0;
        return Math.min((elapsed / total) * 100, 100);
    }
}